import { createReducer, Action, on, createSelector, createFeatureSelector } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';
import { ContractError, User } from 'src/app/core/models/models';
import { OptionType } from 'src/app/core/enums/enums';

export interface AuthState {
  token: string;
  endpoint: string;
  lang: string;
  user: User;
  error: ContractError;
  openSignin: boolean;
}

export const initialAuthState: AuthState = {
  token: null,
  endpoint: null,
  lang: 'en',
  user: null,
  error: null,
  openSignin: false
};

export interface State {
  auth: AuthState;
}

const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.SaveToken, (state, { token }) => ({
    ...state,
    token
  })),
  on(AuthActions.LoadUserInfoSuccess, (state, { user }) => ({
    ...state,
    user,
    openSignin: false
  })),
  on(AuthActions.SaveEndpoint, (state, { endpoint }) => ({
    ...state,
    endpoint
  })),
  on(AuthActions.RefreshToken, (state, { openSignin }) => ({
    ...state,
    openSignin
  })),
  on(AuthActions.SaveLang, (state, { lang }) => ({
    ...state,
    lang
  }))
);

export function reducer(state: AuthState | undefined, action: Action): AuthState {
  return authReducer(state, action);
}

export const selectAuthState = createFeatureSelector<AuthState>(OptionType.Auth);

export const selectToken = createSelector(selectAuthState, (state: AuthState) => state.token);
export const selectUser = createSelector(selectAuthState, (state: AuthState) => state.user);
export const selectOpenSignin = createSelector(
  selectAuthState,
  (state: AuthState) => state.openSignin
);
export const selectEndoint = createSelector(selectAuthState, (state: AuthState) => state.endpoint);
export const selectLang = createSelector(selectAuthState, (state: AuthState) => state.lang);
